import React from 'react';

import { FormattedMessage } from 'react-intl';

import arrowSvg from 'assets/arrow.svg';

import { Container, LeftArrow, RightArrow } from './StartKaraokeMessage.style';

const StartKaraokeMessage: React.FC = () => (
  <Container>
    <LeftArrow src={arrowSvg} />
    <FormattedMessage id='premium-or-free-trial-ongoing-message.start-karaoke' />
    <RightArrow src={arrowSvg} />
  </Container>
);

export default StartKaraokeMessage;
